import React from 'react'
import { Provider } from 'react-redux'
import { store } from './store'
import AppContent from './AppContent'
import version from '../package.json'

const App = () => {
  document.querySelector('meta[name="version"]').setAttribute('content', version.version)

  return (
    <Provider store={store}>
      <AppContent />
    </Provider>
  )
}

export default App
